export interface GetTimeframeSchedulingSettingsRequest {
  facilityCode: string
}

export interface TimeframeSchedulingSettings {
    facilityCode: string,
    earliestStart: string,
    defaultStartTime: string,
    timeFrameWindowLength: string,
    bufferPriorToArrivalTime: string,
    overheadTime: string,
    defaultCommodityUnloadTime : string,
    isDefault: boolean;
  }
  
  export interface SaveTimeframeSchedulingSettingsRequest {
    facilityCode: string,
    earliestStart: string,
    defaultStartTime: string,
    timeFrameWindowLength: string,
    bufferPriorToArrivalTime: string,
    overheadTime: string,
    defaultCommodityUnloadTime : string
  }

  export interface ResetTimeframeSchedulingSettingsRequest {
    facilityCode: string,
    earliestStart: string,
    timeFrameWindowLength: string,
    bufferPriorToArrivalTime: string,
    overheadTime: string,
    defaultCommodityUnloadTime : string
  }

  export class EditTimeframeSchedulingSettingsModel {
    facilityCode: string;
    earliestStart: string;
    defaultStartTime: string;
    timeFrameWindowLength: string;
    bufferPriorToArrivalTime: string;
    overheadTime: string;
    defaultCommodityUnloadTime : string;
    visible: boolean = true;
    saving: boolean = false;
  
    toCreateRequest(): SaveTimeframeSchedulingSettingsRequest {
      return {  facilityCode: this.facilityCode, earliestStart: this.earliestStart, defaultStartTime: this.defaultStartTime, timeFrameWindowLength: this.timeFrameWindowLength, bufferPriorToArrivalTime: this.bufferPriorToArrivalTime, overheadTime: this.overheadTime, defaultCommodityUnloadTime: this.defaultCommodityUnloadTime  };
    }
  }